import { defineMessages } from 'react-intl';

export const estimationStartReviewButtonMessageDefinitions = defineMessages({
  startReviewButton: {
    id: 'estimationDetail.startReviewButton',
    defaultMessage: 'Start Review',
  },
});
